// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"9b62e90a","187":"ffe825f4","538":"024ce470","590":"75d46d43","656":"0a3d7b2c","695":"d4faf9bc"}[chunkId] + ".css";
};